module.exports = __webpack_public_path__ + "static/assets/b2ff5ad3975e6d3f310ef97f9ecd2a89.png";